module.exports = __webpack_public_path__ + "static/thumb1-8ffae156917f0c4991d1426f1ee3c17b.jpg";